export const LOADER_PESO_COMPETENCIA            =   'LOADER_PESO_COMPETENCIA';
export const GET_PESO_COMPETENCIA               =   'GET_PESO_COMPETENCIA';
export const PESO_COMPETENCIA_FALLA             =   'PESO_COMPETENCIA_FALLA';
export const SAVE_LOADER_PESO_COMPETENCIA       =   'SAVE_LOADER_PESO_COMPETENCIA';
export const FORM_PESO_COMPETENCIA_FAIL         =   'FORM_PESO_COMPETENCIA_FAIL';

